import { EditTabsPattern } from '@/components'
import ConfirmDialogContextProvider from '@/components/ConfirmDialogContext'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, History, RecipeEditor, SettingsTab } from './tabs'

export const CustomRecipe = () => {
  const { componentID, useUrl } = useComponentProvider()

  const tabs = [
    { component: <SettingsTab />, name: 'settings' },
    { component: <RecipeEditor />, name: 'code-editor' },
    { component: <History />, name: 'version' },
    { component: <ConfigData />, name: 'config' },
  ]
  return (
    <ConfirmDialogContextProvider>
      <EditTabsPattern
        defaultTab="settings"
        showTabs={!!componentID}
        tabs={tabs}
        urlParams={useUrl}
      />
    </ConfirmDialogContextProvider>
  )
}
